/**
 * <s-favorites-count> — shows the number of favorites inside the header star
 * button and fills the star when the list is not empty.
 *
 * Required child markup:
 *   [data-count]   — badge element; hidden when the list is empty
 *   button         — the trigger; receives data-has-favorites and an updated aria-label
 *
 * Attributes:
 *   data-label     — accessible label template containing [count]
 */
import { getFavorites, onFavoritesChange } from '@theme/favorites-store';

class SFavoritesCount extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    onFavoritesChange(() => this.#sync(), this.#ac.signal);
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const count = getFavorites().length;
    const badge = this.querySelector('[data-count]');
    const button = this.querySelector('a, button');
    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
    if (button) {
      button.toggleAttribute('data-has-favorites', count > 0);
      if (this.dataset.label) button.setAttribute('aria-label', this.dataset.label.replace('[count]', String(count)));
    }
  }
}

if (!customElements.get('s-favorites-count')) customElements.define('s-favorites-count', SFavoritesCount);
